import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { AuditServiceProvider } from '../../api/audit'

const AuditService = AuditServiceProvider()
const name = 'getAuditCreatedBy'

export default (createdby) => (asyncAction(
  name,
  AuditService.getAuditCreatedBy,
  { createdby }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/audit/getAuditCreatedBy.js